import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ScheduleInventoryTransferMutationVariables = Types.Exact<{
  input: Types.ScheduleInventoryTransferInput;
}>;


export type ScheduleInventoryTransferMutation = { __typename?: 'Mutation', scheduleInventoryTransfer: { __typename?: 'ScheduledInventoryTransferPayload', scheduledInventoryTransfer?: { __typename?: 'ScheduledInventoryTransferStateData', scheduledInventoryTransferId: string, status: Types.ScheduledInventoryTransferStatus, locationId: string, itemId: string, grade: number, toItemId: string, toSku: string, effectiveDate: string, quantityMode: Types.ScheduledTransferQuantityMode, fixedQuantity?: number | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelScheduledInventoryTransferMutationVariables = Types.Exact<{
  input: Types.CancelScheduledInventoryTransferInput;
}>;


export type CancelScheduledInventoryTransferMutation = { __typename?: 'Mutation', cancelScheduledInventoryTransfer: { __typename?: 'ScheduledInventoryTransferPayload', scheduledInventoryTransfer?: { __typename?: 'ScheduledInventoryTransferStateData', scheduledInventoryTransferId: string, status: Types.ScheduledInventoryTransferStatus, locationId: string, itemId: string, grade: number, toItemId: string, toSku: string, effectiveDate: string, quantityMode: Types.ScheduledTransferQuantityMode, fixedQuantity?: number | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const ScheduleInventoryTransferDocument = new TypedDocumentString(`
    mutation ScheduleInventoryTransfer($input: ScheduleInventoryTransferInput!) {
  scheduleInventoryTransfer(input: $input) {
    scheduledInventoryTransfer {
      ...ScheduledInventoryTransferStateDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ScheduledInventoryTransferStateDetails on ScheduledInventoryTransferStateData {
  scheduledInventoryTransferId
  status
  locationId
  itemId
  grade
  toItemId
  toSku
  effectiveDate
  quantityMode
  fixedQuantity
}`);
export const CancelScheduledInventoryTransferDocument = new TypedDocumentString(`
    mutation CancelScheduledInventoryTransfer($input: CancelScheduledInventoryTransferInput!) {
  cancelScheduledInventoryTransfer(input: $input) {
    scheduledInventoryTransfer {
      ...ScheduledInventoryTransferStateDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ScheduledInventoryTransferStateDetails on ScheduledInventoryTransferStateData {
  scheduledInventoryTransferId
  status
  locationId
  itemId
  grade
  toItemId
  toSku
  effectiveDate
  quantityMode
  fixedQuantity
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ScheduleInventoryTransfer: build.mutation<ScheduleInventoryTransferMutation, ScheduleInventoryTransferMutationVariables>({
      query: (variables) => ({ document: ScheduleInventoryTransferDocument, variables })
    }),
    CancelScheduledInventoryTransfer: build.mutation<CancelScheduledInventoryTransferMutation, CancelScheduledInventoryTransferMutationVariables>({
      query: (variables) => ({ document: CancelScheduledInventoryTransferDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useScheduleInventoryTransferMutation, useCancelScheduledInventoryTransferMutation } = injectedRtkApi;
